import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';

export const DonorAdvancedSearchSection = () => {
  const { t } = useTranslation();

  return (
    <Box mt={1}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <ControlledTextField bgcolor='white' name='donorName' label={t('gift:donorName')} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField bgcolor='white' name='donorEmail' label={t('gift:donorEmail')} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField bgcolor='white' name='honoredName' label={t('gift:honoredName')} />
        </Grid>
      </Grid>
    </Box>
  );
};
